import axios, { AxiosResponse } from 'axios'

import { Auth } from 'aws-amplify'

const a = axios.create({
  timeout: 8000,
  headers: {
    "Content-Type": "application/json"
  }
})

const withAuthenticationHeader = async () => {
  try {
    const sess = await Auth.currentSession()
    const accessToken = sess.getAccessToken()
    const token = accessToken.getJwtToken()
    return {
      'Authentication': `Bearer ${token}`
    }
  } catch (err) {
    return {}
  }
}

export const post: <T>(path: string, body?: any) => Promise<AxiosResponse<T>> = async (path, body = {}) => {
  const config = {
    headers: await withAuthenticationHeader()
  }
  return a.post(path, body, config)
}

export const get: <T>(path: string) => Promise<AxiosResponse<T>> = async (path) => {
  const config = {
    headers: await withAuthenticationHeader()
  }
  return a.get(path, config)
}
